export default __webpack_public_path__ + "static/media/38k.c46610af.md";